export const CITY_LANDING_PAGE_STRINGS = {
  'meta.title': '{cityName} {stateId} Property Management | Belong PRO',
  'meta.description':
    '{cityName} {stateId} rental home property management the way it should have been all along. Get guaranteed rent, lower vacancy, financing, and more with Belong PRO.',

  'valueProps.title': 'Why Choose Belong Over Property Management?',
  'valueProps.subtitle': 'Earn more. Stress less.',

  'descriptionSection.title':
    '{cityName} deserves better\u00a0than old-school property\u00a0managers.',

  'meetTheTeam.title1':
    'Not\u00a0your\u00a0uncle’s property\u00a0management company.',
  'meetTheTeam.title2': 'Meet our {cityName} Team',
  'meetTheTeam.text': (cityName: string) => (
    <>
      Our local team has{'\u00a0'}over{'\u00a0'}
      <b>
        40+{'\u00a0'}years of{'\u00a0'}real{'\u00a0'}estate
      </b>{' '}
      industry experience in{'\u00a0'}the{'\u00a0'}
      {cityName}.
    </>
  ),

  'neighborhoods.title':
    'We\u00a0proudly\u00a0serve\u00a0these {cityName} neighborhoods.',
  'neighborhoods.text':
    'So\u00a0they’ll\u00a0never\u00a0need\u00a0an\u00a0old-school\u00a0property\u00a0manager.',
  'neighborhoods.button.show': 'SHOW MORE NEIGHBORHOODS',
  'neighborhoods.button.hide': 'HIDE NEIGHBORHOODS',

  'listings.title': (cityName: string) => <>Belong Homes Near {cityName}</>,

  'testimonials.title': 'No more landlords. No more tenants.',
  'testimonials.mobileTitle': "There's a lot of love to go around.",
  'testimonials.text': 'Just happy {cityName} Homeowners and Residents.',
  'video.testimonials.title':
    'From Property Management to Real Belonging: True Stories',

  'calculator.title': 'Get a feel for the guaranteed rent you’ll earn...',
  'ourLocation.title': 'Our {cityName} Location',
  'ourLocation.review': 'VIEW\u00a0REVIEWS',
  'blog.title': 'Read Our Blog',
  'blog.subtitle': 'Your {cityName} guide to a post property managment world.',
  'blog.link': 'View All Articles',
};
